var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function MailIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 13.4142L12.7071 14.7071C12.3166 15.0976 11.6834 15.0976 11.2929 14.7071L10 13.4142L4.411 19.0032L19.5859 19.0001L14 13.4142ZM21 6.41417L15.4142 12L20.9997 17.5855L21 6.41417ZM8.58579 12L3.00026 6.41448L2.99996 17.5858L8.58579 12ZM12 12.6188L19.5935 4.99678L4.40958 4.99989L12 12.6188ZM3.00091 3H20.9991C22.1042 3 23 3.89262 23 4.99509V19.0049C23 20.1068 22.1035 21 20.9991 21H3.00091C1.89584 21 1 20.1074 1 19.0049V4.99509C1 3.89323 1.89655 3 3.00091 3Z", fill: "" })));
}
export var MailIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: MailIconInner }, props))); };
//# sourceMappingURL=MailIcon.js.map